import React from 'react'
import { Trans } from 'react-i18next'
import { ReactComponent as IconLock } from '../../../images/icons/icn-password.svg'
import BtnPrimary from 'components/generic/BtnPrimary'
import registrationApi from 'api/rest/registration'
import styles from './logInToView.module.scss'

const LogInToView = () => {
  return (
    <>
      <IconLock aria-hidden className={styles.icon} />
      <Trans ns='strH2H' i18nKey='loginToView'>
        <BtnPrimary
          linkStyle
          onClick={() => {
            registrationApi.redirectToSignIn({ enableLogging: false })
          }}
        >
          Log in
        </BtnPrimary>{' '}
        to view
      </Trans>
    </>
  )
}

export default LogInToView
